// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".velocityTypeColumn___8T4Fy{display:grid;place-items:baseline}.velocityTypeDropdown___divEF{width:288px!important}\n", "",{"version":3,"sources":["webpack://./src/routes/Parameters/components/VelocityParamStatement/velocityType/velocityType.css"],"names":[],"mappings":"AAAA,4BACE,YAAA,CACA,oBAAA,CAGF,8BACE,qBAAA","sourcesContent":[".velocityTypeColumn {\n  display: grid;\n  place-items: baseline;\n}\n\n.velocityTypeDropdown {\n  width: 288px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"velocityTypeColumn": "velocityTypeColumn___8T4Fy",
	"velocityTypeDropdown": "velocityTypeDropdown___divEF"
};
export default ___CSS_LOADER_EXPORT___;
